import React, { lazy } from "react";
import { Navigate } from "react-router-dom";

//Tables
import ReactTable from "../pages/Tables/ReactTables";

//QA Management
import HomePage from "../pages/QAManagement/HomePage";
import ModuleList from "../pages/QAManagement/ProjectDetailPage";
import ModuleDetailPage from "../pages/QAManagement/ModuleDetailPage";
import UserManagement from "../pages/QAManagement/UserManagement";
import TestResult from "../pages/QAManagement/TestResult";

// import Dashboard from "../pages/QAManagement/Dashboard";
import DocumentContent from "../Components/QAManagementComponent/DocumentContent";

//AuthenticationInner pages
import BasicSignIn from "../pages/AuthenticationInner/Login/BasicSignIn";
import CoverSignIn from "../pages/AuthenticationInner/Login/CoverSignIn";

//pages

import BasicLogout from "../pages/AuthenticationInner/Logout/BasicLogout";
import CoverLogout from "../pages/AuthenticationInner/Logout/CoverLogout";
import Basic404 from "../pages/AuthenticationInner/Errors/Basic404";
import Cover404 from "../pages/AuthenticationInner/Errors/Cover404";
import Alt404 from "../pages/AuthenticationInner/Errors/Alt404";
import Error500 from "../pages/AuthenticationInner/Errors/Error500";
import Offlinepage from "../pages/AuthenticationInner/Errors/Offlinepage";

//login
import Login from "../pages/Authentication/Pages/Login";
import ForgetPasswordPage from "../pages/Authentication/Modal/page/ForgetPassword";
// import Logout from "../pages/Authentication/Logout";
// import Register from "../pages/Authentication/Register";
import ApiKey from "../pages/APIKey/index";

// User Profile
// import UserProfile from "../pages/Authentication/user-profile";

//HR
//Employee
import EmployeeDisplay from "../pages/Pages/Report/ReportDisplay";
import EmployeeWithTxnDetailList from "../pages/Pages/Report/EmployeeWithTxnDetailList";

//Advance
import AdvanceList from "../pages/Pages/AdvanceRecords/AdvanceList";
import AdvanceEditor from "../pages/Pages/AdvanceRecords/AdvanceEditor";
import AdvanceDisplay from "../pages/Pages/AdvanceRecords/AdvanceDisplay";

import CIC from "../pages/Pages/CIC/CIC";
import AddDefaulters from "../pages/Pages/CIC/pages/AddDefaulters";
import Document from "../pages/Pages/Document/Document";
import EmployeeUpdate from "../pages/Pages/Report/ReporUpdate";
import PublicPortal from "../pages/Pages/Public Portal/PublicPortal";

import Detail from "../pages/Pages/Public Portal/Detail";
import DefaultersDetails from "../pages/Pages/CIC/pages/DefaultersDetails";
import ReportWaiting from "../pages/Pages/Report/ReportWaiting";
import ReportApproval from "../pages/Pages/Report/ReportApproval";
import ReportApproved from "../pages/Pages/Report/ReportApproved";
import Dashboard from "../pages/Dashboard/Dashboard";
import ShowCard from "../pages/Pages/Document/ShowCard";
import ReportDetail from "../pages/Pages/Report/ReportDetail";
import ExecutiveForm from "../pages/Pages/Public Portal/ExecutiveForm";
import UserManagementList from "../Components/User Management/User Management";
// import ChangePassword from "../Components/ChangePassword/ChangePassword";
import BalanceSheet from "../pages/Pages/Report/DetailPageReport/BalanceSheet";
import ProfitLoss from "../pages/Pages/Report/DetailPageReport/ProfitLoss";
import PEARLS from "../pages/Pages/Report/DetailPageReport/PEARLS";
import InstitutionDefaultersDetails from "../pages/Pages/CIC/pages/InstitutionDetail";
import ReportEditor from "../pages/Pages/Report/ReportEditor";
import CreateReport from "../pages/Pages/Report/page/CreateReport";
import DraftReport from "../pages/Pages/Report/page/DraftReport";
import ReportList from "../pages/Pages/Report/page/ReportList";

import UserDetail from "../Components/User Management/UserDetail";
import DetailReport from "../pages/Pages/Report/components/DetailReport";
import Package from "../pages/Pages/Packages/Pages/Package";
import Logout from "../pages/Authentication/Pages/Logout";
// import Register from "../pages/Authentication/Pages/Register";
import UserProfile from "../pages/Authentication/Pages/user-profile";
import ModelTest from "../pages/Pages/Packages/Pages/testPage/ModelTest";
import MainPage from "../pages/TravelServicePortal/Pages/MainPage";
// import AboutUs from "../pages/TravelServicePortal/Component/AboutUs/OurTeam";
// import CompanyProfile from "../pages/TravelServicePortal/Component/AboutUs/CompanyProfile";
// import OurTeam from "../pages/TravelServicePortal/Component/AboutUs/OurTeam";
// import Contact from "../pages/TravelServicePortal/Component/ContactUs/Contact";
// import TestimonialPage from "../pages/TravelServicePortal/Component/Testimonials/TestimonialPage";
// import DestinationMain from "../pages/TravelServicePortal/Component/Destination/Page/DestinationMain";
// import DestinationMenu from "../pages/TravelServicePortal/Component/Destination/Page/DestinationMenu";
// import DestinationSubMenu from "../pages/TravelServicePortal/Component/Destination/Page/DestinationSubMenu";
// import DestinationSubSubMenu from "../pages/TravelServicePortal/Component/Destination/Page/DestinationSubSubMenu";
// import Blog from "../pages/TravelServicePortal/Component/Blog/pages/Blog";
// import ServiceDetail from "../pages/TravelServicePortal/Component/ServiceSection/pages/ServiceDetail";
// import Services from "../pages/TravelServicePortal/Component/ServiceSection/pages/Services";
// import BlogDetail from "../pages/TravelServicePortal/Component/Blog/pages/BlogDetail";



// Lazy load components
const CompanyProfile = lazy(() => import('../pages/TravelServicePortal/Component/AboutUs/CompanyProfile'));
const Contact = lazy(() => import('../pages/TravelServicePortal/Component/ContactUs/Contact'));
const TestimonialPage = lazy(() => import('../pages/TravelServicePortal/Component/Testimonials/TestimonialPage'));
const Services = lazy(() => import('../pages/TravelServicePortal/Component/ServiceSection/pages/Services'));
const ServiceDetail = lazy(() => import('../pages/TravelServicePortal/Component/ServiceSection/pages/ServiceDetail'));
const DestinationMain = lazy(() => import('../pages/TravelServicePortal/Component/Destination/Page/DestinationMain'));
const DestinationMenu = lazy(() => import('../pages/TravelServicePortal/Component/Destination/Page/DestinationMenu'));
const DestinationSubMenu = lazy(() => import('../pages/TravelServicePortal/Component/Destination/Page/DestinationSubMenu'));
const DestinationSubSubMenu = lazy(() => import('../pages/TravelServicePortal/Component/Destination/Page/DestinationSubSubMenu'));
const Blog = lazy(() => import('../pages/TravelServicePortal/Component/Blog/pages/Blog'));
const BlogDetail = lazy(() => import('../pages/TravelServicePortal/Component/Blog/pages/BlogDetail'));
const authProtectedRoutes = [
  // { path: "/home", component: <Navigate to="/dashboard" /> },

  //Tables
  { path: "/tables-react", component: <ReactTable /> },

  //HR
  //Employee
  { path: "/report", component: <ReportList /> },
  { path: "/report/detail/:id", component: <DetailReport /> },
  { path: "/report-form", component: <ReportEditor /> },
  { path: "/report-form/:id", component: <ReportEditor /> },
  { path: "/report/:id", component: <ReportDetail /> },
  { path: "/report-waiting-acck", component: <ReportWaiting /> },
  { path: "/report-waiting-approval", component: <ReportApproval /> },
  { path: "/report-waiting-approved", component: <ReportApproved /> },
  { path: "/report-form/details", component: <EmployeeDisplay /> },
  { path: "/report-form/edit/:id", component: <EmployeeUpdate /> },
  {
    path: "/employee-form/viewdetails/:id",
    component: <EmployeeWithTxnDetailList />,
  },

  //  //Advance
  { path: "/advance-form", component: <AdvanceEditor /> },
  { path: "/advance-list", component: <AdvanceList /> },
  { path: "/advance-form/details/:id", component: <AdvanceDisplay /> },
  { path: "/advance-form/edit/:id", component: <AdvanceEditor /> },

  { path: "/dashboard", component: <Dashboard /> },

  { path: "/cic", component: <CIC /> },
  { path: "/cic/add-new-defaulters", component: <AddDefaulters /> },
  { path: "/cic/defaulters-details/:id", component: <DefaultersDetails /> },
  {
    path: "/cic/institution-defaulters-details/:id",
    component: <InstitutionDefaultersDetails />,
  },
  { path: "/cic/edit/:id", component: <AddDefaulters /> },
  { path: "/document", component: <Document /> },
  { path: "/update-profile", component: <PublicPortal /> },
  { path: "/executive-form", component: <ExecutiveForm /> },
  { path: "/view-profile", component: <Detail /> },
  { path: "/show-card", component: <ShowCard /> },

  { path: "/balancesheet", component: <BalanceSheet /> },
  { path: "profitloss", component: <ProfitLoss /> },
  { path: "/pearls", component: <PEARLS /> },

  { path: "/user-management", component: <UserManagementList /> },
  { path: "/user-management/user-detail/:id", component: <UserDetail /> },
  // { path: "/change-password", component: <ChangePassword /> },
  //APIkey
  { path: "/apps-api-key", component: <ApiKey /> },

  //Reports
  { path: "/create-report", component: <CreateReport /> },
  { path: "/draft-report/:id", component: <DraftReport /> },

  //User Profile
  { path: "/profile", component: <UserProfile /> },


  // { path: "/about-us/:names", component: <OurTeam /> },
 
];

const landingRoutes = [];

const publicRoutes = [
  { path: "/", component: <MainPage /> },
  // Authentication Page
  { path: "/logout", component: <Logout /> },
  { path: "/login", component: <Login /> },
  // { path: "/forgot-password", component: <ForgetPasswordModal /> },
  // { path: "/register", component: <Register /> },
  // { path: "/verify", component: <Verify /> },
  //  packages and offers pages
  { path: "/packages", component: <Package /> },
  { path: "/model-test", component: <ModelTest /> },


  //AuthenticationInner pages
  { path: "/auth-signin-basic", component: <BasicSignIn /> },
  { path: "/auth-signin-cover", component: <CoverSignIn /> },
  { path: "/auth-logout-basic", component: <BasicLogout /> },
  { path: "/auth-logout-cover", component: <CoverLogout /> },
  { path: "/auth-404-basic", component: <Basic404 /> },
  { path: "/auth-404-cover", component: <Cover404 /> },
  { path: "/auth-404-alt", component: <Alt404 /> },
  { path: "/auth-500", component: <Error500 /> },
  { path: "/auth-offline", component: <Offlinepage /> },



  //travel link services
  { path: "/:name", component: <CompanyProfile /> },

  { path: "/contact-us", component: <Contact /> },
  { path: "/testimonials", component: <TestimonialPage /> },
  { path: "/services", component: <Services /> },
  { path: "/services/:detail", component: <ServiceDetail /> },
  // destination route
  { path: "/destinations", component: <DestinationMain /> },

  { path: "/destinations/:destination", component: <DestinationMenu /> },
  { path: "/activities/:activity", component: <DestinationSubMenu /> },
  {
    path: "/packages/:subSubMenu",
    component: <DestinationSubSubMenu />,
  },

  {
    path: "/blog",
    component: <Blog />,
  },
  {
    path: "/blog/:detail",
    component: <BlogDetail />,
  },
];

export { authProtectedRoutes, publicRoutes, landingRoutes };
